export default __webpack_public_path__ + "static/media/rupee.81e26202.svg";